<template>
  <div class="dg-message-box" :class="{'dg-message-active':visible}" v-show="visible">
    <div class="dg-message-bg" @click="close"></div>
    <div class="dg-message-dialog-img">
      <!--<img :src="imageUrl">-->
      <viewer
        :options="imgOptions"
        :images="imageUrl"
        @inited="inited"
        class="viewer" ref="viewer"
      >
        <template>
          <figure class="images">
            <!--<img class="image" ref="images" :src="imageUrl">-->
            <template v-for="(item, index) in imageUrl">
              <img :src="item"  class="image" :key="index">
            </template>
          </figure>
        </template>
      </viewer>
      <div class="img-bg" ref="imgBg"></div>
      <div style="width: 2%;height:100%;display: inline-block;vertical-align: middle"></div>
      <ul class="img-btn img-operate">
        <!-- <li @click='originalSize'><i class="icon iconfont icon-quanping1 f22"></i></li>
        <li @click='rotate(90)'><i class="icon iconfont icon-rotateCW"></i></li>
        <li @click='rotate(-90)'><i class="icon iconfont icon-rotateACW"></i></li>
        <li @click='scaleX()'><i class="icon iconfont icon-hflip"></i></li>
        <li @click='scaleY()'><i class="icon iconfont icon-vflip"></i></li>
        <li @click='fitSize(false)'><i class="icon iconfont icon-reset"></i></li>
        <li @click='zoom(-0.2)'><i class="icon iconfont icon-suoxiao f24"></i></li> -->
        <li><span>{{imgPercent}}</span></li>
        <!-- <li @click='zoom(0.2)'><i class="icon iconfont icon-Group- f24"></i></li> -->
      </ul>
      <span class="img-btn close" @click="close"><i class="el-icon-close"></i></span>
      <span class="img-btn pre" @click="preImage"><i class="el-icon-arrow-left"></i></span>
      <span class="img-btn next" @click="nextImage"><i class="el-icon-arrow-right"></i></span>
    </div>
  </div>
</template>

<script>
import 'viewerjs/dist/viewer.css'
import Viewer from './viewer'
import Vue from 'vue'
Vue.use(Viewer)
Viewer.setDefaults({
  zIndexInline: 2017
})
export default {
  data () {
    return {
      visible: false,
      imageUrl: [],
      imgOptions: {
        inline: true,
        button: true,
        navbar: false,
        title: false,
        toolbar: false,
        tooltip: false,
        movable: true,
        zoomable: true,
        rotatable: true,
        scalable: true,
        transition: false,
        fullscreen: true,
        keyboard: true,
        url: 'data-source',
        zoomRatio: 0.2
      },
      form: {
        zoom: 0.2,
        rotate: 90,
        scaleX: 1,
        scaleY: 1
      },
      imgPercent: '0%',
      imageData: {},
      imageList: [],
      showImage: {},
      showIndex: -1
    }
  },
  mounted () {
    if (document.addEventListener) {
      document.addEventListener('DOMMouseScroll', this.updateImgPercent, false);
    } // W3C
    window.onmousewheel = document.onmousewheel = this.updateImgPercent;
    this.$on('open', val => {
      if (val.imageList) {
        this.imageList = val.imageList
      }
      if (val.index || val.index === 0) {
        this.showIndex = val.index;
        this.choseImage();
        this.visible = true;
      }
    })
  },
  destroyed () {
    if (this.updateImgPercent) {
      document.removeEventListener('DOMMouseScroll', this.updateImgPercent);
    }
  },
  methods: {
    inited (viewer) {
      this.$viewer = viewer;
      this.imageData = this.$viewer.imageData;
    },
    close () {
      this.visible = false;
    },
    choseImage () {
      this.showImage = this.imageList[this.showIndex];
      this.url = this.showImage.url;
      this.changeUrl()
    },
    changeUrl () {
      if (!this.url) return;
      // 图片序列添加新图片
      this.imageUrl.push(this.url);
      // this.$viewer.next();
      // 判断是否存在原图片
      if (this.imageUrl.length > 1) {
        // 防止图片渲染异常
        let t1 = setTimeout(() => {
          // 显示新添加的图片
          this.$viewer.next();
          // 删除原图片
          this.imageUrl.shift();
          clearTimeout(t1);
        }, 100);
        // 遮挡图片动画
        this.$refs.imgBg.style.display = 'block';
        let t2 = setTimeout(() => {
          this.$refs.imgBg.style.display = 'none';
          clearTimeout(t2);
        }, 300);
      }
      // 重置图片信息
      let initImgPercent = () => {
        // 防止图片还未渲染进行操作
        let t = setInterval(() => {
          // 判断图片是否渲染完成
          if (this.$viewer && this.$viewer.imageData && this.$viewer.imageData.width) {
            // 计算当前图片百分比
            this.imgPercent = Math.ceil(this.$viewer.imageData.width / this.$viewer.imageData.naturalWidth * 100) + '%';
            let el = document.getElementsByClassName('viewer-canvas')[0];
            if (el) {
              // 获取新渲染的图片对象
              let img = el.getElementsByTagName('img')[0];
              if (img) {
                // 绑定双击事件
                img.ondblclick = (e) => {
                  let imageData = this.$viewer.imageData;
                  let left = imageData.left || 0;
                  let top = imageData.top || 0;
                  let imgData = img.getBoundingClientRect();
                  // 计算偏移位置
                  let x = left - ((e.pageX - imgData.left) * 0.2);
                  let y = top - ((e.pageY - imgData.top) * 0.2);
                  // 放大
                  this.zoom(0.2);
                  // 重置偏移位置
                  this.$viewer.imageData.left = x;
                  this.$viewer.imageData.top = y;
                  let zoom = this.$viewer.imageData.ratio || 1;
                  this.$viewer.zoomTo(zoom); // 重新渲染图形
                  // 阻止向上冒泡事件
                  e.stopPropagation();
                }
              }
            }
            clearInterval(t);
          } else {
            clearInterval(t);
            initImgPercent();
          }
        }, 200);
      };
      initImgPercent();
    },
    scaleX (value) {
      if (value) {
        this.$viewer.scaleX(value)
      } else {
        this.form.scaleX = -this.form.scaleX;
        this.$viewer.scaleX(this.form.scaleX)
      }
    },
    scaleY (value) {
      if (value) {
        this.$viewer.scaleY(value)
      } else {
        this.form.scaleY = -this.form.scaleY;
        this.$viewer.scaleY(this.form.scaleY)
      }
    },
    rotate (value) {
      this.$viewer.rotate(value || this.form.rotate)
    },
    zoom (value) {
      this.$viewer.zoom(value || this.form.zoom);
      this.updateImgPercent();
    },
    toPosition (type1, type2) {
      let el = document.getElementsByClassName('viewer-canvas')[0];
      if (el) {
        let elWidth = el.clientWidth;
        let elHeight = el.clientHeight;
        let img = el.getElementsByTagName('img')[0];
        if (img) {
          if (type1 === 'left') {
            img.style.marginLeft = 0;
            this.$viewer.imageData.left = 0;
          } else if (type1 === 'right') {
            img.style.marginLeft = (elWidth - this.$viewer.imageData.width) + 'px';
            this.$viewer.imageData.left = elWidth - this.$viewer.imageData.width;
          }
          if (type2 === 'top') {
            img.style.marginTop = 0;
            this.$viewer.imageData.top = 0;
          } else if (type2 === 'bottom') {
            img.style.marginTop = (elHeight - this.$viewer.imageData.height) + 'px';
            this.$viewer.imageData.top = elHeight - this.$viewer.imageData.height;
          }
        }
      }
    },
    fitSize (type) {
      let imageData = this.$viewer.imageData;
      let rotate = imageData.rotate || 0;
      let scaleX = imageData.scaleX || 1;
      let scaleY = imageData.scaleY || 1;
      this.$viewer.reset();
      this.updateImgPercent();
      if (type) {
        if (rotate !== 0) this.$viewer.rotateTo(rotate);
        if (scaleX !== 1) this.$viewer.scaleX(scaleX);
        if (scaleY !== 1) this.$viewer.scaleY(scaleY);
      }
    },
    originalSize () {
      this.$viewer.zoomTo(1);
      this.updateImgPercent();
    },
    updateImgPercent () {
      if (this.imageUrl.length > 0) {
        if (this.$viewer && this.$viewer.imageData) {
          this.imgPercent = Math.round(this.$viewer.imageData.width / this.$viewer.imageData.naturalWidth * 100) + '%';
        }
      }
    },
    preImage () {
      if (this.showIndex > 0) {
        this.showIndex--;
      } else {
        this.showIndex = this.imageList.length - 1;
      }
      this.choseImage();
    },
    nextImage () {
      if (this.showIndex < (this.imageList.length - 1)) {
        this.showIndex++;
      } else {
        this.showIndex = 0;
      }
      this.choseImage();
    }
  }
}
</script>
<style lang="scss" scoped>
  .dg-message-box{
  width: 100%;
  position: fixed;
  z-index: 2000;
  height: 100%;
  left: 0;
  top: 0;
  .dg-message-bg{
    position: absolute;
    left: 0;
    top: 0;
    z-index: 0;
    width: 100%;
    height: 100%;
    opacity: .3;
    background-image: -webkit-gradient(linear, left bottom, left top, from(#141E30), to(#243B55));
    background-image: linear-gradient(0deg, #141E30 0%, #243B55 100%);
    animation-duration: .3s;
    animation-fill-mode: both;
    animation-name: showIn;
  }
 .dg-message-dialog-img{
    margin-left: 5%;
    width: 90%;
    position: absolute;
    top:50px;
    bottom:50px;
    text-align: center;
    background-color: #000;
    animation-duration: .3s;
    animation-fill-mode: both;
    animation-name: fadeInDown;
    overflow-x: auto;
    .img-bg{
      background-color: #000;
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 2400;
      display: none;
    }
    //img{
    //  display: inline-block;
    //  max-height: 100%;
    //  max-width: 100%;
    //  position: relative;
    //  vertical-align: middle;
    //}
    .img-btn{
      position: absolute;
      top:20px;
      color: #fff;
      cursor: pointer;
      z-index: 2500;
      i{
        font-size: 20px;
      }
    }
    .img-operate{
      width: 80%;
      text-align: left;
      padding: 0 10px;
      li{
        margin: 5px 10px;
        display: inline-block;
        vertical-align: middle;
        span{
          font-size: 20px;
        }
        .f22{
          font-size: 22px;
        }
        .f24{
          font-size: 24px;
        }
      }
    }
    .close{
      right: 20px;
    }
    .pre{
      top: 45%;
      left: 50px;
      i{
        font-size: 36px;
      }
    }
    .next{
      top: 45%;
      right: 50px;
      i{
        font-size: 36px;
      }
    }
  }
}
</style>
<style lang="scss">
  .viewer{
    display: none;
  }
  .viewer-fullscreen{
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/imageBox.vue